import * as React from "react";
import email from "../../resources/images/correo.png";
import insta from "../../resources/images/insta.png";
import tel from "../../resources/images/tel.png";
import whats from "../../resources/images/whats.png";
import "./footer.scss";

function Footer() {
  return (
    <div className="container">
      <div className="row mt-5 pt-5 mb-4">
        <div className="col text-center">
          <hr className="hr" />
          <h2
            className="mt-4 title-bold text-darkblue"
            style={{ fontSize: "2rem" }}
          >
            CONTACT CENTER UFG
          </h2>
        </div>
      </div>
      <div className="row mb-5 pb-5">
        <div className="col">
          <ul className="social">
            <li>
              <img src={email} alt="" /> contactcenter@ufg.edu.sv
            </li>
            <li>
              <img src={insta} alt="" /> ufg.oficial
            </li>
            <li>
              <img src={tel} alt="" /> 2209-2834
            </li>
            <li>
              <img src={whats} alt="" /> 7554-1471
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Footer;
